import { createContext } from "react";
import type { HttpClient } from "../api/HttpClient";
import type { Credentials, EventEmitter, User } from "../types";

export interface AuthContextValue {
  /** null while loading, or once logged out. */
  user: User | null;
  /** True until the initial session restore (from storage / redirect callback) completes. */
  loading: boolean;
  authenticated: boolean;
  login: (credentials: Credentials) => Promise<void>;
  logout: () => Promise<void>;
  refresh: () => Promise<void>;
  /** Use `auth.client.request(...)` instead of raw `fetch()` for authenticated calls. */
  client: HttpClient;
  events: EventEmitter;
}

export const AuthContext = createContext<AuthContextValue | null>(null);
